import dayjs from 'dayjs';
import shortUUID from 'short-uuid';

import { GLOBAL_DATE_FORMAT } from '../../constants';

export const mapCommunityFeeResponseToData = (item: any) => {
  return {
    id: item?.id,
    key: item ? String(item?.id) : shortUUID.generate(),
    livingTypeId: item?.living_type_id,
    livingType: item?.living_type,
    communityFee: item?.community_fee,
    communityFeeEquivalent: item?.community_fee_equivalent,
    frequency: item?.frequency,
    secondPersonFee: item?.second_person_fee,
    petFee: item?.pet_fee,
    parkingFee: item?.parking_fee,
    respiteFee: item?.respite_fee,
    additionalFee: item?.additional_fee,
    moveInFee: item?.move_in_fee,
    entranceFee: item?.entrance_fee,
    secondPersonEntranceFee: item?.second_person_entrance_fee,
    emergencyPendantFee: item?.emergency_pendant_fee,
    deposit: item?.deposit,
    depositEquivalentFactor: item?.deposit_equivalent_factor,
    createdBy: item?.created_by,
    createdAt: dayjs(new Date(item?.created_at).toDateString(), { format: GLOBAL_DATE_FORMAT }),
    updatedBy: item?.updated_by,
    updatedAt: dayjs(new Date(item?.updated_at).toDateString(), { format: GLOBAL_DATE_FORMAT }),
    date: dayjs(new Date(item?.date).toDateString(), { format: GLOBAL_DATE_FORMAT }),
    contracts: item.contracts,
  };
};

export const mapCareFeeResponseToData = (item: any) => {
  return {
    id: item?.id,
    key: item ? String(item?.id) : shortUUID.generate(),
    feeType: item?.fee_type,
    livingTypeId: item?.living_type_id,
    livingType: item?.living_type,
    pricingTypeId: item?.pricing_type_id,
    pricingType: item?.pricing_type,
    feeNote: item?.fee_note,
    averageCareCost: item?.average_cost,
    averageCost: item?.average_cost,
    level1: item?.level_1,
    level2: item?.level_2,
    level3: item?.level_3,
    level4: item?.level_4,
    level5: item?.level_5,
    level6: item?.level_6,
    level7: item?.level_7,
    level8: item?.level_8,
    createdBy: item?.created_by,
    createdAt: dayjs(new Date(item?.created_at).toDateString(), { format: GLOBAL_DATE_FORMAT }),
    updatedBy: item?.updated_by,
    updatedAt: dayjs(new Date(item?.updated_at).toDateString(), { format: GLOBAL_DATE_FORMAT }),
    date: dayjs(new Date(item?.date).toDateString(), { format: GLOBAL_DATE_FORMAT }),
    contracts: item.contracts,
  };
};
